import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import GroupHome from "../components/group/Home";
import Members from "../components/group/Members";
import IDCard from "../components/group/IDCard";
import PublicIDCard from "../components/group/PublicIDCard";
import GroupCreate from "../components/group/Create";
import GroupSetup from "../components/group/Setup";
import FieldDesigner from "../components/common/FieldDesigner";
import CustomForm from "../components/admin/CustomForm";
import FormResponses from "../components/user/FormResponses";
import GroupDocuments from "../components/group/Documents";
import GroupReview from "../components/group/Review";
import GroupRedirector from "../components/admin/GroupRedirector";
import TenantRedirector from "../components/admin/TenantRedirector";
import GroupCalendar from "../components/group/Calendar";
import Notifications from "../components/Notifications";
import Conversations from "../components/Conversations";
import User from "../components/admin/User";
import AdminGroup from "../components/admin/Group";
import Subscription from "../components/admin/Subscription";
import AdminAffiliate from "../components/admin/Affiliate";
import Campaign from "../components/admin/Campaign";
import DemoData from "../components/admin/DemoData";
import Tenant from "../components/admin/Tenant";
import Integrations from "../components/admin/Integrations";
import Categories from "../components/group/Categories";
import AdminDashboard from "../components/admin/Dashboard";
import BillingDashboard from "../components/admin/Billing";
import Metrics from "../components/admin/Metrics";
import HomeDesigner from "../components/group/HomeDesigner";
import ImageLibrary from "../components/group/ImageLibrary";
import Files from "../components/group/Files";
import DocumentLibrary from "../components/group/DocumentLibrary";
import GroupEvents from "../components/group/Events";
import AdvancedSearch from "../components/event/AdvancedSearch";
import NotFound from "../components/common/NotFound";
import NotAuthorized from "../components/common/NotAuthorized";
import Login from "../components/Login";
import LoginCognito from "../components/LoginCognito";
import TokenLogin from "../components/TokenLogin";
import QuickConnect from "../components/QuickConnect";
import Maintenance from "../components/Maintenance";
import RssFeed from "../components/admin/RssFeed";
import Logout from "../components/Logout";
import Register from "../components/Register";
import Basics from "../components/group/Basics";
import Venue from "../components/group/Venue";
import UserProfile from "../components/user/Profile";
import Pages from "../components/Pages";
import LegacyLink from "../components/admin/LegacyLink";
import AffiliateHome from "../components/affiliate/Home";
import EventViewer from "../components/event/Viewer";
import Jitsi from "../components/Jitsi";
import JitsiLink from "../components/JitsiLink";
import EventGallery from "../components/event/Gallery";
import EventCreator from "../components/event/Creator";
import Banking from "../components/group/Banking";
import FolderPage from "../components/group/FolderPage";
import Billing from "../components/group/Billing";
import Donate from "../components/group/Donate";
import Forum from "../components/group/Forum";
import UserCalendar from "../components/user/Calendar";
import Issues from "../components/Issues";
import HelpMessages from "../components/HelpMessages";
import Galleries from "../components/group/Galleries";
import Keys from "../components/Keys";
import Explore from "../components/Explore";
import Topics from "../components/Topics";
import TopicShow from "../components/TopicShow";
import Features from "../components/Features";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import Form from "../components/Form";
import Leave from "../components/group/Leave";
import Campfire from "../components/campfire/Campfire";
import Presentation from "../components/presentation/Presentation";
import PresentationViewer from "../components/presentation/Viewer";
import Remote from "../components/presentation/Remote";
import GroupBroadcast from "../components/group/Broadcast";
import Announcement from "../components/admin/Announcement";
import Query from "../components/admin/Query";
import DynamicJob from "../components/admin/DynamicJob";
import AnswersSolo from "../components/group/AnswersSolo";
import Accounting from "../components/group/Accounting";
import GroupActivity from "../components/group/Activity";
import Banned from "../components/group/Banned";
import Invitations from "../components/group/Invitations";
import InvitationAccept from "../components/group/InvitationAccept";
import Reputation from "../components/group/Reputation";
import SubscriptionPlans from "../components/group/SubscriptionPlans";
import Subscriptions from "../components/user/Subscriptions";
import SystemSubscriptionPlans from "../components/admin/SystemSubscriptionPlans";
import GroupAssistant from "../components/group/Assistant";
import UserAssistant from "../components/user/Assistant";
import WelcomeEmail from "../components/group/WelcomeEmail";
import UserBilling from "../components/user/Billing";
import Blocks from "../components/user/Blocks";
import MeetupLink from "../components/user/MeetupLink";
import SystemPage from "../components/admin/SystemPage";
import Videos from "../components/admin/Videos";
import CardPageList from "../components/admin/CardPageList";
import CardPage from "../components/admin/CardPage";
import Stamp from "../components/admin/Stamp";
import CardSet from "../components/campfire/CardSet";
import GameDeck from "../components/campfire/GameDeck";
import OwnerChange from "../components/admin/OwnerChange";
import Cards from "../components/Cards";
import Suggest from "../components/event/Suggest";
import SameDayReservation from "../components/group/SameDayReservation";
import PlanShop from "../components/user/PlanShop";
import NewUser from "../components/NewUser";
import Preview from "../components/Preview";
import QuickLink from "../components/QuickLink";
import Player from "../components/campfire/Player";
import FileDownloader from "../components/group/FileDownloader";
import InvalidTenant from "../components/common/InvalidTenant";
import Console from "../components/aws/Console";
import SystemConfig from "../components/admin/SystemConfig";
import SimpleStorageEndpoint from "../components/admin/SimpleStorageEndpoint";
import Discourse from "../components/Discourse";
import TranslateLabels from "../components/admin/TranslateLabels";
import TranslateButtons from "../components/admin/TranslateButtons";
import TranslateDaysMonths from "../components/admin/TranslateDaysMonths";
import TranslateEmailSubjects from "../components/admin/TranslateEmailSubjects";
import TranslateCheckboxes from "../components/admin/TranslateCheckboxes";
import TranslateMenu from "../components/admin/TranslateMenu";
import TranslateMessaging from "../components/admin/TranslateMessaging";
import TranslateUploadDownload from "../components/admin/TranslateUploadDownload";


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/admin/announce',
      name: 'admin-announce',
      component: Announcement
    },
    {
      path: '/admin/aws',
      name: 'aws-console',
      component: Console
    },
    {
      path: '/admin/config',
      name: 'system-config',
      component: SystemConfig
    },
    {
      path: '/admin/storage-endpoints',
      name: 'storage-endpoints',
      component: SimpleStorageEndpoint
    },
    {
      path: '/admin/query',
      name: 'admin-query',
      component: Query
    },
    {
      path: '/admin/jobs',
      name: 'dynamic-job',
      component: DynamicJob
    },
    {
      path: '/page-preview/:id?',
      name: 'page-preview',
      component: Preview
    },
    {
      path: '/admin/stamp',
      name: 'admin-stamp',
      component: Stamp
    },
    {
      path: '/admin/group-redirector',
      name: 'group-redirector',
      component: GroupRedirector
    },
    {
      path: '/admin/tenant-redirector',
      name: 'tenant-redirector',
      component: TenantRedirector
    },
    {
      path: '/file/:id/:accessCode',
      name: 'file-downloader',
      component: FileDownloader
    },
    {
      path: '/group/:id/folder-page/:folderId',
      name: 'folder-page',
      component: FolderPage
    },
    {
      path: '/quick-link',
      name: 'quick-link',
      component: QuickLink
    },
    {
      path: '/admin/subscription',
      name: 'system-subscription-plans',
      component: SystemSubscriptionPlans
    },
    { path: '/play-campfire/:sessionId',
      name: 'play-campfire',
      component: Player
    },
    {
      path: '/user/subscription',
      name: 'user-subscriptions',
      component: Subscriptions
    },
    {
      path: '/campfire/card-set',
      name: 'campfire-card-set',
      component: CardSet
    },
    {
      path: '/campfire/game-deck',
      name: 'campfire-game-deck',
      component: GameDeck
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: AdminDashboard
    },
    {
      path: '/admin/rss',
      name: 'admin-rss-feeds',
      component: RssFeed
    },
    {
      path: '/admin/billing',
      name: 'billing-dashboard',
      component: BillingDashboard
    },
    {
      path: '/admin/metrics',
      name: 'admin-metrics',
      component: Metrics
    },
    {
      path: '/admin/group/:id?',
      name: 'admin-group',
      component: AdminGroup
    },
    {
      path: '/admin/subscription/:id',
      name: 'admin-subscription',
      component: Subscription
    },
    {
      path: '/admin/affiliate/:id?',
      name: 'group-branding-affiliates',
      component: AdminAffiliate
    },
    {
      path: '/admin/campaign',
      name: 'ad-campaigns',
      component: Campaign
    },
    {
      path: '/admin/demo-data',
      name: 'demo-data',
      component: DemoData
    },
    {
      path: '/admin/tenants/:id?',
      name: 'tenant-admin-adm',
      component: Tenant
    },
    {
      path: '/admin/integrations',
      name: 'tenant-integration',
      component: Integrations
    },
    {
      path: '/admin/group-categories',
      name: 'group-categories',
      component: Categories
    },

    {
      path: '/admin/ownerChange/:id',
      name: 'owner-change',
      component: OwnerChange
    },
    /*{
      path: '/admin/brandOwnerChange/:id',
      name: 'brand-owner-change',
      component: BrandOwnerChange
    },*/
    {
      path: '/admin/image',
      name: 'admin-image',
      component: ImageLibrary
    },
    {
      path: '/admin/pages',
      name: 'admin-pages',
      component: SystemPage
    },
    {
      path: '/admin/links',
      name: 'legacy-links',
      component: LegacyLink
    },
    {
      path: '/admin/videos',
      name: 'admin-videos',
      component: Videos
    },
    {
      path: '/admin/card-pages',
      name: 'card-pages',
      component: CardPageList
    },
    {
      path: '/admin/card-page/:id',
      name: 'card-page',
      component: CardPage
    },
    {
      path: '/admin/help/:action?/:id?',
      name: 'help-messages',
      component: HelpMessages
    },
    {
      path: '/explore',
      name: 'explore',
      component: Explore
    },
    {
      path: '/topics',
      name: 'topics',
      component: Topics
    },
    {
      path: '/topic/:uri',
      name: 'topic',
      component: TopicShow
    },

    {
      path: '/features',
      name: 'features',
      component: Features
    },

    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: "/issues/:action?/:id?",
      name: "issues",
      component: Issues
    },
    {
      path: '/login/oauth2/code/cognito',
          name: 'login-oauth-cognito',
          component: LoginCognito
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/token-login/:token?',
      name: 'token-login',
      component: TokenLogin
    },
    {
      path: '/quick-connect/:code?',
      name: 'quick-connect',
      component: QuickConnect
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/maintenance',
      name: 'maintenance-mode',
      component: Maintenance
    },
    { path: '/calendar',
      name: 'user-calendar',
      component: UserCalendar
    },
    { path: '/page/:id',
      name: 'public-page',
      component: Pages
    },
    { path: '/affiliate/:id',
      name: 'affiliate-home',
      component: AffiliateHome
    },
    { path: '/cards/:id',
      name: 'public-cards',
      component: Cards
    },
    { path: '/newGroup',
      name: 'group-create',
      component: GroupCreate
    },
    { path: '/group/setup/:id',
      name: 'group-setup',
      component: GroupSetup
    },
    { path: '/group/:id',
      name: 'group-home',
      component: GroupHome
    },
    { path: '/group/:id/basics',
      name: 'group-basics',
      component: Basics
    },
    { path: '/group/:id/activity',
      name: 'group-activity',
      component: GroupActivity
    },
    { path: '/group/:id/campfire',
      name: 'group-campfire',
      component: Campfire
    },
    { path: '/group/:id/presentation',
      name: 'group-presentation',
      component: Presentation
    },
    { path: '/presentation-viewer/:sessionId',
      name: 'presentation-viewer',
      component: PresentationViewer
    },
    { path: '/presentation-remote/:sessionId',
      name: 'presentation-remote',
      component: Remote
    },
    { path: '/group/:id/accounting',
      name: 'group-account',
      component: Accounting
    },
    { path: '/group/:id/answers',
      name: 'group-answers',
      component: AnswersSolo
    },
    { path: '/group/:id/banned',
      name: 'group-banned',
      component: Banned
    },
    { path: '/group/:id/invitations',
      name: 'group-invitations',
      component: Invitations
    },
    { path: '/accept-invitation',
      name: 'accept-invitation',
      component: InvitationAccept
    },
    { path: '/group/:id/reputation',
      name: 'group-reputation',
      component: Reputation
    },
    { path: '/group/:id/subscription-plans',
      name: 'group-subscription-plans',
      component: SubscriptionPlans
    },
    { path: '/group/:id/assistant',
      name: 'group-assistant',
      component: GroupAssistant
    },
    { path: '/group/:id/welcome-email',
      name: 'group-welcome-email',
      component: WelcomeEmail
    },
    { path: '/group/:id/broadcast',
      name: 'group-broadcast',
      component: GroupBroadcast
    },
    { path: '/group/:id/galleries',
      name: 'group-galleries',
      component: Galleries
    },
    { path: '/group/:id/leave',
      name: 'group-leave',
      component: Leave
    },
    { path: '/group/:id/designer',
      name: 'group-home-designer',
      component: HomeDesigner
    },
    { path: '/group/:id/members/:member?',
      name: 'group-members',
      component: Members
    },
    { path: '/group/:id/image-library',
      name: 'group-image-library',
      component: ImageLibrary
    },
    { path: '/group/:id/files',
      name: 'group-files',
      component: Files
    },
    { path: '/group/:id/content',
      name: 'group-document-library',
      component: DocumentLibrary
    },
    { path: '/group/:id/venue/:venueId?',
      name: 'group-venues',
      component: Venue
    },
    { path: '/group/:id/banking',
      name: 'group-banking',
      component: Banking
    },
    { path: '/group/:id/calendar',
      name: 'group-calendar',
      component: GroupCalendar
    },
    { path: '/group/:id/forum/:forumId?',
      name: 'group-forum',
      component: Forum
    },
    { path: '/group/:id/billing',
      name: 'group-billing',
      component: Billing
    },
    { path: '/group/:id/donate',
      name: 'group-donation',
      component: Donate
    },
    { path: '/custom-fields/member/:group',
      name: 'group-fields',
      component: FieldDesigner
    },
    { path: '/group/:id/review',
      name: 'group-review',
      component: GroupReview
    },
    { path: '/group/:id/events',
      name: 'group-events',
      component: GroupEvents
    },
    { path: '/group/:id/event-search',
      name: 'group-events',
      component: AdvancedSearch
    },
    { path: '/member/:id/events',
      name: 'member-events',
      component: GroupEvents
    },
    { path: '/member/:id/id-card',
      name: 'id-card',
      component: IDCard
    },
    { path: '/member/qrcode',
      name: 'public-id-card',
      component: PublicIDCard
    },
    { path: '/group/:groupId/docs/:documentId',
      name: 'group-documents',
      component: GroupDocuments
    },
    {
      path: '/group/:groupId/card-pages',
      name: 'group-card-pages',
      component: CardPageList
    },
    {
      path: '/group/:groupId/card-page/:id',
      name: 'group-card-page',
      component: CardPage
    },
    { path: '/group/:groupId/cards/:id',
      name: 'group-cards',
      component: Cards
    },
    { path: '/notifications',
      name: 'user-notifications',
      component: Notifications
    },
    { path: '/conversations/:id?',
      name: 'conversations',
      component: Conversations
    },
    { path: '/users/:id?/:action?',
      name: 'system-users',
      component: User
    },
    { path: '/user/profile',
      name: 'user-profile',
      component: UserProfile
    },
    { path: '/user/events',
      name: 'user-events',
      component: GroupEvents
    },
    { path: '/user/blocks',
      name: 'user-blocks',
      component: Blocks
    },
    { path: '/user/meetupLink',
      name: 'meetup-link',
      component: MeetupLink
    },
    { path: '/user/billing',
      name: 'user-billing',
      component: UserBilling
    },
    { path: '/user/plan-shopper',
      name: 'plan-shopper',
      component: PlanShop
    },
    { path: '/user/assistant',
      name: 'user-assistant',
      component: UserAssistant
    },
    { path: '/user/keys',
      name: 'user-keys',
      component: Keys
    },
    { path: '/new-user',
      name: 'new-user',
      component: NewUser
    },
    { path: '/event/show/:id/:action?',
      name: 'event-viewer',
      component: EventViewer
    },
    { path: '/event/gallery/:id',
      name: 'event-gallery',
      component: EventGallery
    },
    { path: '/meeting',
      name: 'jitsi-meeting',
      component: Jitsi
    },
    { path: '/meeting-guest/:id',
      name: 'jitsi-guest',
      component: JitsiLink
    },
    { path: '/sso/discourse',
      name: 'discourse-sso',
      component: Discourse
    },
    { path: '/event/suggest/:id',
      name: 'event-suggestion',
      component: Suggest
    },
    { path: '/contact',
      name: 'contact-form',
      component: Contact
    },
    { path: '/form/:name',
      name: 'custom-form',
      component: Form
    },
    { path: '/custom/form-responses',
      name: 'form-responses',
      component: FormResponses
    },
    { path: '/custom-fields/user',
      name: 'user-field-designer',
      component: FieldDesigner
    },
    { path: '/custom-fields/form/:id',
      name: 'form-field-designer',
      component: FieldDesigner
    },
    { path: '/custom/settings',
      name: 'tenant-admin-settings',
      component: Tenant
    },
    { path: '/custom/forms/:id?',
      name: 'tenant-admin-forms',
      component: CustomForm
    },
    { path: '/reservation/same-day/:id',
      name: 'same-day-reservation',
      component: SameDayReservation
    },
    { path: '/event/photoComments/:id',
      redirect: '/event/gallery/:id'
    },
    {
      path: '/event/eventGallery/:id', redirect: '/event/gallery/:id'
    },
    { path: '/event/new/:id',
      name: 'new-event',
      component: EventCreator
    },
    { path: '/translate/labels',
      name: 'translate-common-labels',
      component: TranslateLabels
    },
    { path: '/translate/buttons',
      name: 'translate-common-buttons',
      component: TranslateButtons
    },
    { path: '/translate/daysMonths',
      name: 'translate-days-months',
      component: TranslateDaysMonths
    },
    { path: '/translate/email-subjects',
      name: 'translate-email-subjects',
      component: TranslateEmailSubjects
    },
    { path: '/translate/menu-items',
      name: 'translate-menu-items',
      component: TranslateMenu
    },
    { path: '/translate/messaging',
      name: 'translate-messaging',
      component: TranslateMessaging
    },
    { path: '/translate/checkboxes',
      name: 'translate-common-checkboxes',
      component: TranslateCheckboxes
    },
    { path: '/translate/upload-download',
      name: 'translate-upload-download',
      component: TranslateUploadDownload
    },
    { path: '/404', component: NotFound },
    { path: '/invalidTenant', component: InvalidTenant },
    { path: '/403', component: NotAuthorized, name: "not-authorized" },
    { path: '*', redirect: '/404' }
  ]
});
